"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormFieldLabel = getFormFieldLabel;
exports.generateFormField = generateFormField;
exports.getOrderForNewField = getOrderForNewField;
exports.appendFormField = appendFormField;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("underscore");

function getFormFieldLabel(_ref, locale) {
  var name = _ref.name,
      label = _ref.label;
  var lookupKey = "standardFormFields." + name;

  if (_I18n.default.lookup(lookupKey, {
    locale: locale
  })) {
    var original = _I18n.default.translate(lookupKey, {
      locale: 'en'
    });

    var translated = _I18n.default.translate(lookupKey, {
      locale: locale
    });

    if (!label || label === original) {
      return translated;
    } else {
      return label;
    }
  }

  return label;
}

function generateFormField(_ref2, locale) {
  var name = _ref2.name,
      label = _ref2.label;
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'string';
  var formType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'text';
  return {
    displayOrder: order,
    formType: formType,
    label: getFormFieldLabel({
      name: name,
      label: label
    }, locale),
    name: name,
    type: type
  };
}

function getOrderForNewField(existingFields) {
  var orders = (existingFields || []).map(function (el) {
    return el.displayOrder;
  });
  var highestOrder = Math.max.apply(Math, (0, _toConsumableArray2.default)(orders));
  return existingFields.length > 0 ? highestOrder + 1 : 0;
}

function appendFormField(existingFields, field) {
  var newFieldList = (0, _underscore.clone)(existingFields);
  var newField = Object.assign({}, field, {
    displayOrder: getOrderForNewField(existingFields)
  });
  newFieldList.push(newField);
  return newFieldList;
}